/**
 * 第三方应用名称
 */
enum THIRD_APP_NAME {
  WECHAT = 'wechat', // 微信
}

/**
 * 第三方iOS应用对应Scheme
 */
enum THIRD_APP_SCHEME {
  WECHAT = 'weixin://', // 微信
}

/**
 * 第三方Andorid应用对应包名
 */
enum THIRD_APP_PACKAGE {
  WECHAT = 'com.tencent.mm', // 微信
}

export { THIRD_APP_SCHEME, THIRD_APP_PACKAGE, THIRD_APP_NAME }
